import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import FormDialog from 'atoms/FormDialog'
import { withRouter } from 'react-router'
import { connectGetters } from 'react-redux-getters'
import connectActions from 'utils/connectActions'
import { getPermissions } from 'selectors/permissions'
import { getMe } from 'selectors/me'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import { postInsight } from 'actions/status'

import { closeUnlockFeatureDialog } from './actions'


const mapStateFromProps = state => ({
  open: state.unlockFeatureDialog
})

const mapDispatchToProps = {
  closeUnlockFeatureDialogAction: closeUnlockFeatureDialog
}

const mapGettersToProps = state => ({
  permissionsGetter: getPermissions(state),
  meGetter: getMe(state),
})

const mapActionsToProps = {
  postInsightAction: postInsight
}

export default
@connectActions(mapActionsToProps)
@connect(mapStateFromProps, mapDispatchToProps)
@connectGetters(mapGettersToProps)
@withRouter
class BillingUnlockFeatureDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    closeUnlockFeatureDialogAction: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    permissionsGetter: PropTypes.object.isRequired,
    postInsightAction: PropTypes.object.isRequired,
    meGetter: PropTypes.object.isRequired,
  }

  handleSubmit = async () => {
    const { history, postInsightAction } = this.props
    history.push('/billing')
    postInsightAction.run({
      params: [document.location.pathname],
    })
  }

  render() {
    const { open, closeUnlockFeatureDialogAction, permissionsGetter, meGetter } = this.props
    const showUpgradeButton = permissionsGetter.data.billingTab
    const trialEnabled = showUpgradeButton && !meGetter.data.trialFinished
    return (
      <FormDialog
        open={open}
        onSubmit={this.handleSubmit}
        onClose={closeUnlockFeatureDialogAction}
        applyButton={showUpgradeButton && <Button>Upgrade</Button>}
        cancelButton={<Button>Cancel</Button>}
        title="Upgrade your plan to unlock this feature"
      >
        { trialEnabled && (
          <DialogContent>
            <Typography>
              Click Upgrade to start a free trial
            </Typography>
          </DialogContent>
        ) }
      </FormDialog>
    )
  }
}
